import declare from "dojo/_base/declare";
import Action from "csi/def/Action";
import xml from "csi/xml";

const PackListReopen = declare(Action, {
	/**
	 * @override
	 * ignore frozen flag when checking access to Abandoned pack list
	 */
	checkNodeAccess: function(node, ctx) {
		return xml.nodeHasRight(node, this.m_right);
	},
});

export = PackListReopen;
	